var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        _vm._g(
          _vm._b(
            {
              ref: _vm.reftext,
              staticClass: "liststyle",
              attrs: {
                data: _vm.data,
                height: _vm.height,
                "element-loading-text": _vm.$t("common.loadingText"),
                border: true,
                heigth: _vm.height,
              },
              on: { "header-dragend": _vm.changes },
            },
            "el-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.hasC
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              })
            : _vm._e(),
          _vm.hasNO
            ? _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  type: "index",
                  width: "50",
                  label: "序号",
                  align: "center",
                  index: _vm.indexMethod,
                },
              })
            : _vm._e(),
          _vm._l(
            this.pageConfig.length == 0 ? _vm.col : this.collist,
            function (item, index) {
              return _c("el-table-column", {
                key: "col_" + index,
                attrs: {
                  prop:
                    _vm.pageConfig.length == 0
                      ? _vm.dropCol[index].prop
                      : _vm.collist[index].prop,
                  label: item.label,
                  width: item.Width,
                  "min-width": "100px",
                  align: "center",
                },
              })
            }
          ),
          _vm._t("default"),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("el-empty", {
                attrs: { description: "暂无数据", "image-size": 120 },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }